import React from 'react';
import PropTypes from 'prop-types'
import { Notification } from 'react-admin';

import RegisterForm from '../custom_components/UserCreateForm'


const Register = () => {
  
   return (
       <React.Fragment>
        <RegisterForm
            showLogos={true}
            showInfo={true}
            redirect={'/login'}
            onComplete={(e: any) => {}} />

        <Notification />
       </React.Fragment>

   ) 
};

Register.propTypes = {
    // authProvider: PropTypes.func,
    previousRoute: PropTypes.string,
};


const RegisterWithTheme = (props: any) => (

            <Register {...props} />

);

export default RegisterWithTheme;